import React, { createContext, ReactNode, useContext } from 'react';
import { WorkflowsService } from '../ports/WorkflowService';

// tslint:disable-next-line:variable-name
const WorkflowsServiceContext = createContext<WorkflowsService | undefined>(undefined);

// tslint:disable-next-line:variable-name
export const WorkflowsServiceProvider = (
  {
    children,
    service,
  }: {
    children: ReactNode | ReactNode[],
    service: WorkflowsService,
  },
) => <WorkflowsServiceContext.Provider value={service}>
  {children}
</WorkflowsServiceContext.Provider>;

export const useWorkflowsService = () => useContext(WorkflowsServiceContext);
